"use client";
interface DivProps extends React.HTMLAttributes<HTMLDivElement> {
    
}
export default function FormBody({children,className,...rest}:DivProps){
    return <div {...rest} className="rounded-md bg-gray-50 p-4 md:p-6" >
        {children}
    </div>
}